import { ServiceCardsCartProps } from '@/types/serviceCards.types';
import styles from './serviceCardsCard.module.scss';
import Image from 'next/image';

const ServiceCards3Cart = ({ card }: ServiceCardsCartProps) => {
  const { title, description, icon } = card;

  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardWrapper}>
        <div className={styles.cardIcon}>
          <Image src={icon} alt={title} width={80} height={80} />
        </div>
        <div className={styles.cardContent}>
          <h3 className={styles.cardTitle}> {title}</h3>
          <p
            className={styles.cardDescription}
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          ></p>
        </div>
      </div>
    </div>
  );
};

export default ServiceCards3Cart;
